import { ASM } from "./AppStateMachine";
import { DVER } from "divine-voxel-engine/Render";
import { RenderSystem } from "../../system/render/RenderSystem";
import { APP_STATE } from "./AppState";
import { UISystem } from "../../system/ui/UISystem";
export function SetUpAppEvents() {
    ASM.addToStates({
        INIT: {
            LOAD_DATA: async () => { },
            INIT_DVE: async () => { },
            START: async () => { },
        },
    }).addToStates({
        IDLE: {
            ETNER_GAME: () => {
                UISystem.show(false);
                APP_STATE.mode = "world-loading";
                UISystem.appScreen.update("world-loading", "world-loading");
                DVER.worldComm.runPromiseTasks("start-world", APP_STATE.world, [], () => {
                    RenderSystem.setCanvasVisability(true);
                    APP_STATE.mode = "in-game";
                    UISystem.show(false);
                    UISystem.appScreen.update("", "");
                    RenderSystem.setCanvasInteractive(true);
                    RenderSystem.enterPointerLock();
                });
            },
        },
    });
    return ASM;
}
